module.exports = __webpack_public_path__ + "static/media/fly0062.b712a99b.webp";